import getConfig from 'next/config'

const getcdn = (uri: string) => {
  const { publicRuntimeConfig: { CDN_URL } } = getConfig()
  uri = `${CDN_URL}/${uri}`
  uri = uri.replace(/\/+/gi, '/').replace(':/', '://')
  return uri
}

export default getcdn
